import { Component } from 'vue';
import { RouteMeta, RouteRecordRaw } from 'vue-router';
import { useTranslation } from '@hfc/ui-core';

type RouteRecordRawWithMeta = RouteRecordRaw & { meta: RouteMeta };

export class MetalPlanRouteCollection {

  private routes: Array<RouteRecordRawWithMeta> = [];

  public constructor (metalPlans: Array<{ href: string; title: string; description: string; metallicPlanName: string; component: Component }>) {
    const { t } = useTranslation();

    this.routes = metalPlans.map(metalPlan => ({
      path: `/covered-california/plans/${metalPlan.href}`,
      name: this.getMetallicPlanRouteName(metalPlan.metallicPlanName),
      meta: {
        layout: 'HomePage',
        title: metalPlan.title,
        description: metalPlan.description,
        theme: 'light',
        breadcrumbs: [
          {
            label: 'California Health Insurance',
            href: '/'
          },
          {
            label: 'Covered California',
            href: `/${t('links.coveredCalifornia')}`
          },
          {
            label: 'Plans',
            href: '/covered-california/plans'
          },
          {
            label: this.getMetallicPlanBreadcrumbLabel(metalPlan.metallicPlanName),
            href: `/covered-california/plans/${metalPlan.href}`
          }
        ]
      },
      props: {
        planName: metalPlan.metallicPlanName
      },
      component: metalPlan.component
    }));
  }

  private getMetallicPlanRouteName (metallicPlanName: string): string {
    const splittedMetallicPlanName = metallicPlanName.split('_');
    const capitalizedWords = splittedMetallicPlanName.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

    return capitalizedWords.join('');
  }

  private getMetallicPlanBreadcrumbLabel (metallicPlanName: string): string {
    const splittedMetallicPlanName = metallicPlanName.split('_');
    const capitalizedWords = splittedMetallicPlanName.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

    return capitalizedWords.join(' ');
  }

  public getRoutes (): Array<RouteRecordRawWithMeta> {
    return this.routes;
  }

}
